var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 186",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00006 4.93005C7.53356 4.93005 7.96606 4.49755 7.96606 3.96405C7.96606 3.43054 7.53356 2.99805 7.00006 2.99805C6.46655 2.99805 6.03406 3.43054 6.03406 3.96405C6.03406 4.49755 6.46655 4.93005 7.00006 4.93005Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1476",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.483 11.0007H6.517C6.384 11.0007 6.276 10.8927 6.276 10.7597V6.50467C6.276 6.37167 6.384 6.26367 6.517 6.26367H7.483C7.616 6.26367 7.724 6.37167 7.724 6.50467V10.7587C7.724 10.8927 7.616 11.0007 7.483 11.0007Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1477",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C3.14 14 0 10.86 0 7C0 3.14 3.14 0 7 0C10.86 0 14 3.14 14 7C14 10.86 10.86 14 7 14ZM7 1.448C3.938 1.448 1.448 3.938 1.448 7C1.448 10.062 3.938 12.552 7 12.552C10.062 12.552 12.552 10.062 12.552 7C12.552 3.938 10.062 1.448 7 1.448Z",
    fill: "#606060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeInfo);
export default __webpack_public_path__ + "static/media/themeInfo.3d40c616f4a0f323a93ff9f6c1735a82.svg";
export { ForwardRef as ReactComponent };